import { render } from "./ExamsResultsComponent.vue?vue&type=template&id=3e7c7704&scoped=true"
import script from "./ExamsResultsComponent.vue?vue&type=script&lang=js"
export * from "./ExamsResultsComponent.vue?vue&type=script&lang=js"

import "./ExamsResultsComponent.vue?vue&type=style&index=0&id=3e7c7704&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e7c7704"]])

export default __exports__